// src/components/CircularScreenLoader.tsx
import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import { CircularScreenLoaderStyles } from "../styles/component/CircularScreenLoader.styles";
const CircularScreenLoader = ({ loading }: { loading: boolean }) => {
  return (
    <Backdrop sx={CircularScreenLoaderStyles} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
export default React.memo(CircularScreenLoader);
